import { isAppAllowed } from '@cartwhl/common/appletPolicy';
import type { AppEntitlement } from '@cartwhl/common/types';

/** Studio ships as Canvas externally, so the entitlement slug is `canvas`. */
export const STUDIO_APP_ENTITLEMENT: AppEntitlement = 'canvas';

export type CanvasEntitlement = 'loading' | 'allowed' | 'denied';

export type CanvasEntitlementInput = {
  authStatus: 'anonymous' | 'user';
  /** `userStore.state.loading` — true while the signed-in user's org is being fetched. */
  userStoreLoading: boolean;
  organizationInfo: { allowedApps?: readonly AppEntitlement[] } | undefined;
};

/**
 * Anonymous visitors have no organization, so the whitelist never applies to
 * them. For a signed-in user we wait for the organization to arrive rather than
 * guessing, but a load that finishes without one still falls through to full
 * access: an org that never opted into a whitelist must see Canvas unchanged.
 */
export function getCanvasEntitlement({
  authStatus,
  userStoreLoading,
  organizationInfo,
}: CanvasEntitlementInput): CanvasEntitlement {
  if (authStatus !== 'user') {
    return 'allowed';
  }

  if (!organizationInfo) {
    return userStoreLoading ? 'loading' : 'allowed';
  }

  return isAppAllowed(STUDIO_APP_ENTITLEMENT, organizationInfo.allowedApps)
    ? 'allowed'
    : 'denied';
}
